import { ValidationFailure } from "../../../errors/validation-failure";
import Guard from "../../../guard";
import { IRequestByUsername } from "../request-by-username";
import { ValidatorBase } from "./validator-base";

export class RequestByUsernameValidator extends ValidatorBase {
    validate(requestByUsername: IRequestByUsername): Array<ValidationFailure> {
        Guard.notNull(requestByUsername);

        if (requestByUsername.recipients == null) {
            const failure = new ValidationFailure(`Recipients cannot be null.`);
            this.addFailure(failure);
        }

        if (requestByUsername.recipients.length === 0) {
            const failure = new ValidationFailure(`At least 1 recipient must be specified.`);
            this.addFailure(failure);
        }

        try {
            Guard.arrayNoneNullOrEmptyString(requestByUsername.recipients);
        } catch (error) {
            const failure = new ValidationFailure(`Usernames cannot be null or whitespace.`);
            this.addFailure(failure);
        }

        return this.getFailures();
    }
}
